import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { Dokument } from './dokument.model';

@Injectable({
  providedIn: 'root',
})
export class DokumentApi extends RestApi<Dokument> {
  endpoint = '/api/admin/dokumenter';
}
